// extracted by mini-css-extract-plugin
module.exports = {"list":"scheduleResultsFAQsAccordion_list__Rgr7P","text":"scheduleResultsFAQsAccordion_text__unmgs"};